import React from 'react'

import { Box } from '@mui/material'
import ParticelleForm from './ParticelleForm'
import SensoriForm from './SensoriForm'



export const TerreniSensoriSlider = ({ cantine, setCantine }) => {

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Sensore</h2>
            </Box>
            <SensoriForm cantine={cantine} setCantine={setCantine} />
        </Box>
    )
}
